import { ProductionConfig } from '../production-config';
import type { AppConfig } from '../types';
import { PUBLIC_APP_ENV } from '$app/env/public';

export const Config: AppConfig =
	PUBLIC_APP_ENV === 'preview'
		? Object.freeze({
				...ProductionConfig,
				AuthDomain: 'https://silver-squirrel.no-zero.net',
				PolicyName: 'stormy-sun.no-zero.net',
				Domain: 'https://stormy-sun.no-zero.net',
				GraphqlApiKey: 'PJ87qdgwKHXJ2JKqUnMONR2uFw4-rqUo',
			})
		: ProductionConfig;
